import React from "react";
import ReactDOM from 'react-dom';
import Button from "../Button";

export default class Modal extends React.Component {
  constructor(props){
    super(props);
    this.modalRef = React.createRef(null)
  }
  componentDidMount(){
    if(this.props.visible){
      document.body.style.overflowY = "hidden"
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.visible!==this.props.visible){
      if(this.props.visible){
        document.body.style.overflowY = "hidden"
      }else{
        if(document.querySelectorAll(".customModalMask").length === 0){
          document.body.style.overflowY = "unset"
        }
      }
    }
  }

  destroy = () =>{
    this.props.onCancel && this.props.onCancel(); 
    this.modalRef.current.remove();
  }
  render() {
    const { 
      visible = false,
      setVisible = ()=>{},
      footer=true, 
      header=true,
      className = "",
      title = "",
      cancelText = "Cancel",
      okText = "OK",
      onlyOkBtn = false,
      onOk = () => {}, 
      disabled=false,
      fullscreen,
      children 
    } = this.props;
    return (
      visible ? (
        ReactDOM.createPortal((
          <div ref={this.modalRef} className={`depositModalMask customModalMask ${className}`}>
            <div className={`modalCotent customModalCotent`}>
              {header && (
                <div className={`modalTitle customModalTitle`}>{title}</div>
              )}
              <div className={`modalBody customModalBody`}>{children}</div>
              {!fullscreen && footer && (
                <div className={`modalButtonBox customModalButtonBox`}>
                  {!onlyOkBtn && (
                    <Button ghost className='cancelBtn'onClick={this.destroy}>{cancelText}</Button>
                  )}
                  <Button className='okBtn' onClick={onOk} disabled={disabled}>{okText}</Button>
                </div>
              )}
            </div>
          </div> 
        ) , document.body
        )) : (
        null
      )
    );
  }
}
